"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaypalPatchOperations = void 0;
const src_1 = require("..");
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
function getPaypalPatchOperations(hasOptionSelected) {
    const { available_shipping_lines: shippingLines } = (0, checkout_frontend_library_1.getShipping)();
    const patchOperations = [
        {
            op: 'replace',
            path: '/purchase_units/@reference_id==\'default\'/amount',
            value: (0, src_1.getPaypalAmountWithBreakdown)()
        }
    ];
    (shippingLines === null || shippingLines === void 0 ? void 0 : shippingLines.length) > 0 && patchOperations.push({
        op: hasOptionSelected ? 'replace' : 'add',
        path: '/purchase_units/@reference_id==\'default\'/shipping/options',
        value: (0, src_1.getPaypalShippingOptions)()
    });
    return patchOperations;
}
exports.getPaypalPatchOperations = getPaypalPatchOperations;
